export default __webpack_public_path__ + "static/media/7.d1e21ef8.jpeg";